import { EMAIL_PLACEHOLDER_TAGS } from 'features/EmailEditor/constants'

const PLACEHOLDER_PATTERN = /(\{\{\s*[a-zA-Z][a-zA-Z0-9]*\s*\}\})/g

// Zero width space, used to park the caret right after an inserted chip.
export const CARET_ANCHOR = '\u200b'

export function findPlaceholderTag(placeholder) {
  const normalized = (placeholder || '').replace(/\s+/g, '')
  return EMAIL_PLACEHOLDER_TAGS.find(tag => tag.placeholder === normalized) || null
}

// Breaks the raw template into text runs and the placeholders we know how to
// render as chips. Unknown placeholders stay as plain text so a typo stays visible.
export function splitPlaceholders(value) {
  return (value || '')
    .split(PLACEHOLDER_PATTERN)
    .filter(part => part !== '')
    .map(part => {
      const tag = findPlaceholderTag(part)
      return tag ? { type: 'tag', value: tag.placeholder, label: tag.label } : { type: 'text', value: part }
    })
}

export function stripCaretAnchors(value) {
  return (value || '').split(CARET_ANCHOR).join('')
}

// Reads the contenteditable back into the plain text the backend stores.
export function serializeTaggedField(element) {
  if (!element) {
    return ''
  }

  let text = ''

  const visit = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent
      return
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return
    }

    const placeholder = node.getAttribute?.('data-placeholder')
    if (placeholder) {
      text += placeholder
      return
    }

    if (node.tagName === 'BR') {
      text += '\n'
      return
    }

    node.childNodes.forEach(visit)
  }

  element.childNodes.forEach(visit)

  return stripCaretAnchors(text).replace(/\u00a0/g, ' ')
}
